import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PlusIcon from "../components/common/Icons/PlusIcon";
import PageHeader from "../components/common/PageHeader";
import DepartmentSettingsTable from "../components/Settings/Department/DepartmentSettingsTable";
import RoleSettingsTable from "../components/Settings/Roles/RoleSettingsTable";

const RoleSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Container>
      <PageHeader
        pageTitle="Rol Listesi"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Rol"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <RoleSettingsTable />
    </Container>
  );
};

export default RoleSettings;
